import { jsxs as i, jsx as l } from "react/jsx-runtime";
const s = (h) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ...h,
    children: [
      /* @__PURE__ */ l("path", { fill: "#FEBA08", d: "M13.434 12.841h8.409v8.409h-8.409z" }),
      /* @__PURE__ */ l("path", { fill: "#05A6F0", d: "M3.343 12.841h8.409v8.409H3.343z" }),
      /* @__PURE__ */ l("path", { fill: "#80BC06", d: "M13.434 2.75h8.409v8.409h-8.409z" }),
      /* @__PURE__ */ l("path", { fill: "#F25325", d: "M3.343 2.75h8.409v8.409H3.343z" })
    ]
  }
);
export {
  s as default
};
